import { createContext, useCallback, useContext, useMemo } from 'react';

import { useGraphql } from '../../hooks/graphql';
import { useLoad } from '../../hooks/load';

const SessionContext = createContext();

// Who is signed in, and how far through onboarding they are. Everything the
// router decides — sign-in screens, an onboarding step, or the app — follows
// from this one answer, so it is asked once here and asked again with refresh
// whenever something changes it: a verified code, a saved step, signing out.
//
// me is undefined while the first answer is on its way or when it failed, and
// null for a signed-out visitor, so the router can tell "not yet known" from
// "nobody". error and retry are useLoad's: a failed first answer is a screen
// with a way to ask again, never an empty page.
export function SessionProvider({ children }) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({ document: `query Me {
      me { id email role onboardingStep profile { firstName lastName birthDate gender fiscalCode appearance } }
    }` }).then(function(data) {
      return data.me;
    });
  }, [ graphql ]);

  const { data, error, retry, reload } = useLoad(read);

  const value = useMemo(function() {
    return { me: data, error, retry, refresh: reload };
  }, [ data, error, retry, reload ]);

  return <SessionContext.Provider value={ value }>{ children }</SessionContext.Provider>;
}

export function useSession() {
  return useContext(SessionContext);
}
